export const TERMS_SCENE = Object.freeze({
  id: "cold-archive-passage",
  version: "2026-07-21.1",
  environment: Object.freeze({
    assetId: "orbital-commons-world-master",
    poster: "/assets/world-films/orbital-commons-poster.webp",
    sources: Object.freeze([
      Object.freeze({ src: "/assets/world-films/orbital-commons.webm", type: "video/webm" }),
      Object.freeze({ src: "/assets/world-films/orbital-commons.mp4", type: "video/mp4" }),
    ]),
    desktopObjectPosition: "54% 50%",
    mobileObjectPosition: "66% 50%",
  }),
  timing: Object.freeze({
    cycleMs: 17800,
    restEnd: 0.12,
    chargeEnd: 0.22,
    traverseEnd: 0.64,
    holdEnd: 0.72,
    decayEnd: 0.91,
  }),
  path: Object.freeze([
    Object.freeze({ x: -0.1, y: 0.72 }),
    Object.freeze({ x: 0.035, y: 0.56 }),
    Object.freeze({ x: 0.09, y: 0.22 }),
    Object.freeze({ x: 0.28, y: 0.105 }),
    Object.freeze({ x: 0.52, y: 0.12 }),
    Object.freeze({ x: 0.76, y: 0.1 }),
    Object.freeze({ x: 0.92, y: 0.25 }),
    Object.freeze({ x: 1.08, y: 0.54 }),
  ]),
  layers: Object.freeze([
    Object.freeze({ id: "atmospheric-halo", width: 25, blur: 30, offset: 13, seed: 0.4, continuous: true, rgb: "30,153,211", alpha: 0.055, shadow: "rgba(27,151,210,.36)" }),
    Object.freeze({ id: "filament-body", width: 9, blur: 17, offset: 9, seed: 1.7, continuous: true, rgb: "78,202,240", alpha: 0.2, shadow: "rgba(77,202,240,.7)" }),
    Object.freeze({ id: "turbulent-core", width: 2.35, blur: 8, offset: 6, seed: 3.1, continuous: false, rgb: "146,233,255", alpha: 0.78, shadow: "rgba(154,238,255,.94)" }),
    Object.freeze({ id: "white-hot-leader", width: 0.86, blur: 2.5, offset: 3.1, seed: 4.9, continuous: false, rgb: "246,254,255", alpha: 0.98, shadow: "rgba(255,255,255,.98)" }),
  ]),
  performance: Object.freeze({ maxDevicePixelRatio: 1.6, targetFps: 40 }),
});
